import { render, staticRenderFns } from "./ChangelogPreview.vue?vue&type=template&id=5f036b24&scoped=true&lang=pug&"
import script from "./ChangelogPreview.vue?vue&type=script&lang=js&"
export * from "./ChangelogPreview.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogPreview.vue?vue&type=style&index=0&id=5f036b24&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f036b24",
  null
  
)

export default component.exports